module.exports = __webpack_public_path__ + "img/a216828.png";